import { InterestsPreference } from 'integration/generated/transactions/data-contracts';

type Args = {
	selectedSports?: string[];
	selectedTeams?: string[];
	selectedDayByDay?: string[];
	sports?: InterestsPreference;
	teams?: InterestsPreference;
	dayByDay?: InterestsPreference;
};

export const generateDpFanUpdateBody = ({
	selectedSports,
	selectedTeams,
	selectedDayByDay,
	sports,
	teams,
	dayByDay,
}: Args): { parentId: number; children: number[] }[] => {
	const sportsIds =
		sports?.children
			?.filter((sport) => selectedSports?.includes(sport.name))
			.map((sport) => sport.id) ?? [];

	const teamsIds =
		teams?.children?.filter((team) => selectedTeams?.includes(team.name)).map((team) => team.id) ??
		[];

	const dayByDayIds =
		dayByDay?.children
			?.filter((dayByDay) => selectedDayByDay?.includes(dayByDay.name))
			.map((dayByDay) => dayByDay.id) ?? [];

	const payload: { parentId: number; children: number[] }[] = [];

	if (sports) {
		payload.push({
			parentId: sports.id,
			children: sportsIds,
		});
	}

	if (teams) {
		payload.push({
			parentId: teams.id,
			children: teamsIds,
		});
	}

	if (dayByDay) {
		payload.push({
			parentId: dayByDay.id,
			children: dayByDayIds,
		});
	}

	return payload;
};
